import { atom } from 'recoil';

export const cookieUpdate = atom({
  key: 'cookieUpdate',
  default: false,
});
